/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../../core/components';
import { Component } from '@angular/core';
import { MenuService } from '../../../../../core/services';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-menu-footer',
    templateUrl: './menu-footer.component.html',
    styleUrls: ['./menu-footer.component.scss']
})
export class MenuFooterComponent extends BaseComponent {
    /**
     * Store the menu state.
     */
    public menuOpen: boolean = true;

    /**
     * Store the tooltip state.
     * @param menuService
     */
    public tooltipToggle: boolean = false;

    /**
     * Store the menu type
     */
    public menuIsHover: boolean = false;

    constructor(
        public menuService: MenuService,
    ) {
        super();

        if (!this.menuIsHover) {
            this.menuOpen = this.menuService.menuState;
            this.setUpMenuSubscriber();
        }
    }

    /**
     * Toggle the tooltip.
     */
    public toggleTooltip(): void {
        this.tooltipToggle = !this.tooltipToggle;
    }

    /**
     * Subscribe to the menu service.
     */
    public setUpMenuSubscriber(): void {
        this.menuService.menuIsOpen
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (state: boolean): void => {
                    this.menuOpen = state;

                    if (state) {
                        this.tooltipToggle = false;
                    }
                }
            });

        this.menuService.menuTypeIsHover
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (state: boolean): void => {
                    this.menuIsHover = state;
                }
            });
    }
}
